import { action } from "framework/config/action";
import { URLS } from "framework/config/urls";
import { useSubmitProps } from "../types";
import { parseError } from "../utils";

export function useSubscribe({ onSuccess, onError }: useSubmitProps) {
  const submit = action(URLS.newsletters);

  const handleSubscribe = async ({ values, form }) => {
    const response = await submit(values);

    form.submitting(false);

    if (response.isOK) {
      onSuccess?.(response.data);
      form.reset();
    } else {
      onError?.(parseError(response));
    }
  };

  return { handleSubscribe };
}
